import styled from 'styled-components';
import {ButtonBase, CenteredSpaceWrap} from '../../../CommonStyleUtils/dwebCommon.styles';

export const BannerContainer = styled(CenteredSpaceWrap)(
  props => `
  flex-wrap: wrap;
  border-radius: ${props.theme.misc.borderRadius.large};
  background-color: ${props.theme.colors.goBrandBlue.medium};
  padding:${props.theme.spacing.xlarge};
  margin-top:${props.theme.spacing.large};
`,
);

export const TextWrap = styled.div(
  props => `

  font-size:${props.theme.font.custom(16)};
  font-family: ${props.theme.font.fontFamily};
  color:${props.theme.colors.goBrandBlue.base};
  font-weight:bold;
  margin-left:${props.theme.spacing.xlarge}
`,
);

export const BannerLeftWrap = styled.div`
  display: flex;
  align-items: center;
  width: 75%;
`;

export const ButtonWrap = styled(ButtonBase)(
  props => `
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  background-color: ${props.theme.colors.goWhite.base};
  color:${props.theme.colors.goBrandBlue.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  text-transform:capitalize;
  font-size:${props.theme.font.custom(14)};
  color:${props.theme.colors.goBrandBlue.base};
`,
);
